import { axios } from '@/utils/request'

const api = {

  master: '/system/sysExam',
}
// 列表
export function queryOrderList (parameter) {
  return axios({
    url: api.master + '/getWebExamQuestionList',
    method: 'get',
    params: parameter
  })
}

// 保存
export function updateExamQuestion (parameter) {
  return axios({
    url: api.master + '/updateExamQuestion',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 详情
export function getExamQuestionInfo (id) {
  return axios({
    url: api.master + '/getExamQuestionInfo',
    method: 'get',
    params: {
      questionId:id
    }
  })
}
